import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DICT_DETAIL',
        create: 'DICT_CREATE',
        update: 'DICT_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'dict_name',
        default: '',
        label: '名称',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.dict_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dict_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dict_type',
        default: '',
        label: '标识',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.dict_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dict_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dict_value_type',
        default: this.$env.VUE_APP_DICT_DICT_VALUE_TYPE_NUMBER,
        label: '数据类型',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "dict_value_type",
              "disabled": _this.mode !== 'create',
              "button": true
            },
            "model": {
              value: _this.form.model.dict_value_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dict_value_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: this.$env.VUE_APP_DICT_STATUS_ACTIVE,
        label: '状态',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  }
};